export default {"src":"/_next/static/media/rocketOne.df0309e1.svg","height":23,"width":21};